import _slicedToArray from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty2 from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { j as Connector, _ as _classPrivateMethodInitSpec, r as _defineProperty, s as _classPrivateFieldInitSpec, n as normalizeChainId, U as UserRejectedRequestError, t as _classPrivateFieldGet, u as _classPrivateFieldSet, k as ChainNotConfiguredError, v as _classPrivateMethodGet, A as AddChainError, o as SwitchChainError } from '../../../dist/getProvider-8f5b3a0d.esm.js';
import { providers } from 'ethers';
import { getAddress, hexValue } from 'ethers/lib/utils';
import 'zustand/middleware';
import 'zustand/vanilla';
import 'eventemitter3';
import '../../../dist/chains-5ceae8b1.esm.js';
import '../../../dist/rpcs-6e1b1718.esm.js';

var _client = /*#__PURE__*/new WeakMap();

var _provider = /*#__PURE__*/new WeakMap();

var _isUserRejectedRequestError = /*#__PURE__*/new WeakSet();

var CoinbaseWalletConnector = /*#__PURE__*/function (_Connector) {
  _inherits(CoinbaseWalletConnector, _Connector);

  var _super = _createSuper(CoinbaseWalletConnector);

  function CoinbaseWalletConnector(_ref) {
    var _this;

    _classCallCheck(this, CoinbaseWalletConnector);

    var chains = _ref.chains,
        options = _ref.options;
    _this = _super.call(this, {
      chains: chains,
      options: _objectSpread({
        reloadOnDisconnect: false
      }, options)
    });

    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _isUserRejectedRequestError);

    _defineProperty(_assertThisInitialized(_this), "id", 'coinbaseWallet');

    _defineProperty(_assertThisInitialized(_this), "name", 'Coinbase Wallet');

    _defineProperty(_assertThisInitialized(_this), "ready", true);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _client, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _provider, {
      writable: true,
      value: void 0
    });

    _defineProperty(_assertThisInitialized(_this), "onAccountsChanged", function (accounts) {
      if (accounts.length === 0) _this.emit('disconnect');else _this.emit('change', {
        account: getAddress(accounts[0])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChainChanged", function (chainId) {
      var id = normalizeChainId(chainId);

      var unsupported = _this.isChainUnsupported(id);

      _this.emit('change', {
        chain: {
          id: id,
          unsupported: unsupported
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDisconnect", function () {
      _this.emit('disconnect');
    });

    return _this;
  }

  _createClass(CoinbaseWalletConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref3,
            chainId,
            provider,
            accounts,
            account,
            id,
            unsupported,
            chain,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref3 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, chainId = _ref3.chainId;
                _context.prev = 1;
                _context.next = 4;
                return this.getProvider();

              case 4:
                provider = _context.sent;
                provider.on('accountsChanged', this.onAccountsChanged);
                provider.on('chainChanged', this.onChainChanged);
                provider.on('disconnect', this.onDisconnect);
                this.emit('message', {
                  type: 'connecting'
                });
                _context.next = 11;
                return provider.enable();

              case 11:
                accounts = _context.sent;
                account = getAddress(accounts[0]); // Switch to chain if provided

                _context.next = 15;
                return this.getChainId();

              case 15:
                id = _context.sent;
                unsupported = this.isChainUnsupported(id);

                if (!(chainId && id !== chainId)) {
                  _context.next = 23;
                  break;
                }

                _context.next = 20;
                return this.switchChain(chainId);

              case 20:
                chain = _context.sent;
                id = chain.id;
                unsupported = this.isChainUnsupported(id);

              case 23:
                return _context.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: new providers.Web3Provider(provider)
                });

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](1);

                if (!/(user closed modal|accounts received is empty)/i.test(_context.t0.message)) {
                  _context.next = 30;
                  break;
                }

                throw new UserRejectedRequestError(_context.t0);

              case 30:
                throw _context.t0;

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 26]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var provider;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_classPrivateFieldGet(this, _provider)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return this.getProvider();

              case 4:
                provider = _context2.sent;
                provider.removeListener('accountsChanged', this.onAccountsChanged);
                provider.removeListener('chainChanged', this.onChainChanged);
                provider.removeListener('disconnect', this.onDisconnect);
                provider.disconnect();
                provider.close();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var provider, accounts;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getProvider();

              case 2:
                provider = _context3.sent;
                _context3.next = 5;
                return provider.request({
                  method: 'eth_accounts'
                });

              case 5:
                accounts = _context3.sent;
                return _context3.abrupt("return", getAddress(accounts[0]));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAccount() {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var provider, chainId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getProvider();

              case 2:
                provider = _context4.sent;
                chainId = normalizeChainId(provider.chainId);
                return _context4.abrupt("return", chainId);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getProvider",
    value: function () {
      var _getProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var chain, chainId, jsonRpcUrl, CoinbaseWalletSDK;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_classPrivateFieldGet(this, _provider)) {
                  _context5.next = 10;
                  break;
                }

                chain = this.chains.find(function (chain) {
                  return chain.id === _this2.options.chainId;
                }) || this.chains[0];
                chainId = this.options.chainId || (chain === null || chain === void 0 ? void 0 : chain.id);
                jsonRpcUrl = this.options.jsonRpcUrl || (chain === null || chain === void 0 ? void 0 : chain.rpcUrls.default);
                _context5.next = 6;
                return import('@coinbase/wallet-sdk');

              case 6:
                CoinbaseWalletSDK = _context5.sent.default;
                // Workaround for Vite dev import errors
                // https://github.com/vitejs/vite/issues/7112
                if (typeof CoinbaseWalletSDK !== 'function' && // @ts-expect-error This import error is not visible to TypeScript
                typeof CoinbaseWalletSDK.default === 'function') CoinbaseWalletSDK = CoinbaseWalletSDK.default;

                _classPrivateFieldSet(this, _client, new CoinbaseWalletSDK(this.options));

                _classPrivateFieldSet(this, _provider, _classPrivateFieldGet(this, _client).makeWeb3Provider(jsonRpcUrl, chainId));

              case 10:
                return _context5.abrupt("return", _classPrivateFieldGet(this, _provider));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getProvider() {
        return _getProvider.apply(this, arguments);
      }

      return getProvider;
    }()
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _yield$Promise$all, _yield$Promise$all2, provider, account;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Promise.all([this.getProvider(), this.getAccount()]);

              case 2:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                provider = _yield$Promise$all2[0];
                account = _yield$Promise$all2[1];
                return _context6.abrupt("return", new providers.Web3Provider(provider).getSigner(account));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getSigner() {
        return _getSigner.apply(this, arguments);
      }

      return getSigner;
    }()
  }, {
    key: "isAuthorized",
    value: function () {
      var _isAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var account;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.getAccount();

              case 3:
                account = _context7.sent;
                return _context7.abrupt("return", !!account);

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", false);

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function isAuthorized() {
        return _isAuthorized.apply(this, arguments);
      }

      return isAuthorized;
    }()
  }, {
    key: "switchChain",
    value: function () {
      var _switchChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(chainId) {
        var provider, id, _this$chains$find, chain, _chain$rpcUrls$public;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getProvider();

              case 2:
                provider = _context8.sent;
                id = hexValue(chainId);
                _context8.prev = 4;
                _context8.next = 7;
                return provider.request({
                  method: 'wallet_switchEthereumChain',
                  params: [{
                    chainId: id
                  }]
                });

              case 7:
                return _context8.abrupt("return", (_this$chains$find = this.chains.find(function (x) {
                  return x.id === chainId;
                })) !== null && _this$chains$find !== void 0 ? _this$chains$find : {
                  id: chainId,
                  name: "Chain ".concat(id),
                  network: "".concat(id),
                  rpcUrls: {
                    default: ''
                  }
                });

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](4);
                chain = this.chains.find(function (x) {
                  return x.id === chainId;
                });

                if (chain) {
                  _context8.next = 15;
                  break;
                }

                throw new ChainNotConfiguredError();

              case 15:
                if (!(_context8.t0.code === 4902)) {
                  _context8.next = 27;
                  break;
                }

                _context8.prev = 16;
                _context8.next = 19;
                return provider.request({
                  method: 'wallet_addEthereumChain',
                  params: [{
                    chainId: id,
                    chainName: chain.name,
                    nativeCurrency: chain.nativeCurrency,
                    rpcUrls: [(_chain$rpcUrls$public = chain.rpcUrls.public) !== null && _chain$rpcUrls$public !== void 0 ? _chain$rpcUrls$public : chain.rpcUrls.default],
                    blockExplorerUrls: this.getBlockExplorerUrls(chain)
                  }]
                });

              case 19:
                return _context8.abrupt("return", chain);

              case 22:
                _context8.prev = 22;
                _context8.t1 = _context8["catch"](16);

                if (!_classPrivateMethodGet(this, _isUserRejectedRequestError, _isUserRejectedRequestError2).call(this, _context8.t1)) {
                  _context8.next = 26;
                  break;
                }

                throw new UserRejectedRequestError(_context8.t1);

              case 26:
                throw new AddChainError();

              case 27:
                if (!_classPrivateMethodGet(this, _isUserRejectedRequestError, _isUserRejectedRequestError2).call(this, _context8.t0)) {
                  _context8.next = 29;
                  break;
                }

                throw new UserRejectedRequestError(_context8.t0);

              case 29:
                throw new SwitchChainError(_context8.t0);

              case 30:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[4, 10], [16, 22]]);
      }));

      function switchChain(_x) {
        return _switchChain.apply(this, arguments);
      }

      return switchChain;
    }()
  }, {
    key: "watchAsset",
    value: function () {
      var _watchAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref2) {
        var address, _ref2$decimals, decimals, image, symbol, provider;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                address = _ref2.address, _ref2$decimals = _ref2.decimals, decimals = _ref2$decimals === void 0 ? 18 : _ref2$decimals, image = _ref2.image, symbol = _ref2.symbol;
                _context9.next = 3;
                return this.getProvider();

              case 3:
                provider = _context9.sent;
                _context9.next = 6;
                return provider.request({
                  method: 'wallet_watchAsset',
                  params: {
                    type: 'ERC20',
                    options: {
                      address: address,
                      decimals: decimals,
                      image: image,
                      symbol: symbol
                    }
                  }
                });

              case 6:
                return _context9.abrupt("return", _context9.sent);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function watchAsset(_x2) {
        return _watchAsset.apply(this, arguments);
      }

      return watchAsset;
    }()
  }]);

  return CoinbaseWalletConnector;
}(Connector);

function _isUserRejectedRequestError2(error) {
  return /(user rejected)/i.test(error.message);
}

export { CoinbaseWalletConnector };